import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle<{
  maxInfoWindowWidth: number;
  customCSS: string;
}>`
  /* Google Maps Styles */
  .gm-style {
    overflow: hidden;
  }

  /* GM - Info Window */
  .gm-style-iw-t::after {
    pointer-events: none;
  }

  .gm-style-iw-d {
    overflow: hidden;
  }
  
  div.gm-style-iw {
    max-width: ${({ maxInfoWindowWidth }) => maxInfoWindowWidth}px!important;
  }

  .gm-style-iw.gm-style-iw-c {
    padding: 14px!important;
    pointer-events: none;

    button {
      pointer-events: auto;
      &:focus {
        outline: black;
      }
    }
  }

  /* GM - Autocomplete */
  .pac-container {
    width: 100%;
    height: 15vh;
    overflow: auto;
  }
  
  .pac-logo::after {
    display: none;
  }

  /* GM - Street View (Top Left) Exit and More Info Tab */
  #cy-google-map > div:nth-child(1) > div:nth-child(2) > div:nth-child(4) > div:nth-child(1) {
    left: ${({ theme }) => theme.layout.sideMenuPosition === 'right' || (theme.layout.sideMenuPosition === 'left' && theme.layout.isMobile)
      ? '0'
      : theme.layout.sideMenuWidth}!important;
  }

  #cy-google-map > div:nth-child(1) > div:nth-child(2) > div:nth-child(4) > div:nth-child(2) {
      left:${({ theme }) => theme.layout.sideMenuPosition === 'right' || (theme.layout.sideMenuPosition === 'left' && theme.layout.isMobile)
      ? "0"
      : `calc(${theme.layout.sideMenuWidth} + 27px)!important`};
    }

    /* GM - Street View full screen, zoom, and rotation control*/
  .gm-fullscreen-control {
    right:${({ theme }) => theme.layout.sideMenuPosition === 'right' && !theme.layout.isMobile
    ? theme.layout.sideMenuWidth
    : '10px'
    }!important
  }

  .gmnoprint {
    right:${({ theme }) => theme.layout.sideMenuPosition === 'right' && !theme.layout.isMobile  
    ? `calc(${theme.layout.sideMenuWidth} + 45px)` 
    : '45px'
    }!important
  }
  
  /* Scroll Buttons */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Custom CSS (Admin Console) */
  ${({ customCSS }) => customCSS}
`;

export default GlobalStyles;
